import { twMerge } from "tailwind-merge";
import type { Article } from "@core/features/support";
import { MdxRenderer } from "@themes/pollinator/ui/MdxRenderer";
import { MdxRendererTableOfContents } from "@themes/pollinator/ui/MdxRendererTableOfContents";

export type Props = {
  article: Article;
  className?: string;
  children?: React.ReactNode;
  isTableOfContentsVisible?: boolean;
};

export function StaticPage({
  article,
  className,
  children,
  isTableOfContentsVisible = false,
}: Props) {
  return (
    <div
      className={twMerge(
        "flex flex-col flex-1 w-full max-w-xl justify-between relative overflow-x-hidden",
        className
      )}
    >
      {isTableOfContentsVisible && (
        <MdxRendererTableOfContents content={article.content || ""} />
      )}
      <MdxRenderer content={article.content || ""} />
      {children}
    </div>
  );
}

export default StaticPage;

